import React, { useRef, useEffect } from 'react';
import ScriptEditor from './ScriptEditor';
import './BrowserWithScriptEditor.css';

function BrowserWithScriptEditor({ url, setUrl }) {
  const urlInput = useRef();
  const scriptEditorRef = useRef();

  // Listen for content insertion event from PromptForm
  useEffect(() => {
    const handleContentInsertion = (event) => {
      if (scriptEditorRef.current && scriptEditorRef.current.insertGeneratedContent) {
        scriptEditorRef.current.insertGeneratedContent(event.detail.content);
      }
    };

    window.addEventListener('insertContentToEditor', handleContentInsertion);
    return () => window.removeEventListener('insertContentToEditor', handleContentInsertion);
  }, []);

  const handleBookmarkClick = (bookmarkUrl) => {
    setUrl(bookmarkUrl);
    if (urlInput.current) {
      urlInput.current.value = bookmarkUrl;
    }
  };

  return (
    <div className="browser-view-card">
      {/* Browser controls at the top */}
      <div className="browser-url-bar-top-wrapper">
        {/* Bookmark links */}
        <div className="browser-bookmarks">
          <button 
            type="button" 
            className="browser-bookmark-btn" 
            onClick={() => handleBookmarkClick('https://fideantech.com')}
            title="Fideantech"
          >
            Fideantech
          </button>
          <button 
            type="button" 
            className="browser-bookmark-btn" 
            onClick={() => handleBookmarkClick('https://www.linkedin.com/')}
            title="LinkedIn"
          >
            LinkedIn
          </button>
          <button 
            type="button" 
            className="browser-bookmark-btn" 
            onClick={() => handleBookmarkClick('https://www.facebook.com/')}
            title="Facebook"
          >
            Facebook
          </button>
          <button 
            type="button" 
            className="browser-bookmark-btn" 
            onClick={() => handleBookmarkClick('https://business.facebook.com/')}
            title="Business Suite"
          >
            Business Suite
          </button>
          <button 
            type="button" 
            className="browser-bookmark-btn" 
            onClick={() => handleBookmarkClick('https://canva.com')}
            title="Canva"
          >
            Canva
          </button>
          <button 
            type="button" 
            className="browser-bookmark-btn" 
            onClick={() => handleBookmarkClick('https://www.instagram.com/')}
            title="Instagram"
          >
            Instagram
          </button>
          <button 
            type="button" 
            className="browser-bookmark-btn" 
            onClick={() => handleBookmarkClick('https://web.whatsapp.com/')}
            title="WhatsApp Web"
          >
            WhatsApp Web
          </button>
          <button 
            type="button" 
            className="browser-bookmark-btn" 
            onClick={() => handleBookmarkClick('https://www.tiktok.com/')}
            title="TikTok"
          >
            TikTok
          </button>
          <button 
            type="button" 
            className="browser-bookmark-btn" 
            onClick={() => handleBookmarkClick('https://x.com/')}
            title="X"
          >
            X
          </button>
          <button 
            type="button" 
            className="browser-bookmark-btn" 
            onClick={() => handleBookmarkClick('https://www.youtube.com/')}
            title="YouTube"
          >
            YouTube
          </button>
        </div>
        <form className="browser-url-bar-top" onSubmit={(e) => e.preventDefault()} autoComplete="off">
          <input
            ref={urlInput}
            type="text"
            defaultValue={url}
            placeholder="Enter URL (e.g. https://fideantech.com)"
            className="browser-url-input"
            autoFocus={false}
          />
          <button
            type="button"
            className="browser-url-load-btn"
            onClick={() => {
              const currentUrl = urlInput.current.value;
              if (window.electronAPI && window.electronAPI.openInWebview2) {
                // Launch WebView2 in modal
                window.electronAPI.openInWebview2(currentUrl);
              } else {
                // Fallback for browser mode
                console.log('Running in browser mode - opening Secure Browser in new tab');
                window.open(currentUrl, '_blank');
              }
            }}
            title="Open in Secure Browser (Edge WebView2)"
          >
            Secure Browser
          </button>
        </form>
        <div className="browser-session-controls">
          <button 
            type="button" 
            className="browser-session-btn" 
            onClick={() => {
              if (window.electronAPI && window.electronAPI.clearAllSessions) {
                if (confirm('This will log you out from all websites. Continue?')) {
                  window.electronAPI.clearAllSessions();
                }
              }
            }}
            title="Logout from all sites"
          >
            Clear Sessions
          </button>
        </div>
      </div>
      {/* Script Editor instead of webview */}
      <div className="script-editor-container">
        <ScriptEditor ref={scriptEditorRef} />
      </div>
    </div>
  );
}

export default BrowserWithScriptEditor;
